import branches from "@config/branches.json";
import SectionTitle from "../components/SectionTitle.jsx";

export default function Branches() {
  return (
    <section className="section-shell py-14">
      <SectionTitle title="Branch Network" text="Future branches will load dynamically from the branch configuration file." />
      <div className="grid gap-5 md:grid-cols-3">
        {branches.map((branch) => (
          <article key={branch.id} className="premium-card p-6">
            <span className="rounded-full bg-gold px-3 py-1 text-xs font-black text-ink">{branch.status}</span>
            <h2 className="mt-4 text-2xl font-black text-royal">{branch.name}</h2>
            <p className="mt-3 leading-7 text-muted">{branch.address}</p>
            <p className="font-bold text-maroon">{branch.city}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
